module.exports = __webpack_public_path__ + "img/no-available-icon.svg";